import { ChainId } from '@traderjoe-xyz/joepegs-sdk'
import { ParsedAttribute } from 'utils/attributes'

export type Chain = 'avalanche'

export enum ChainQueryParam {
  ALL = 'all',
  AVALANCHE = 'avalanche'
}

export enum CollectionVerificationStatus {
  Trusted = 'verified_trusted',
  Unverified = 'unverified',
  Verified = 'verified'
}

export enum CollectionType {
  ERC721 = 'erc721',
  ERC1155 = 'erc1155'
}

export interface CollectionAttributeValue {
  count: number
  value: string
}

export interface CollectionAttribute {
  traitType: string
  values: CollectionAttributeValue[]
}

export interface Collection {
  address: string
  chain: Chain
  chainId: ChainId
  name: string
  symbol: string
  type: CollectionType
  verified: CollectionVerificationStatus
  bannerUrl?: string
  description?: string
  discordUrl?: string
  numItems?: number
  pfpUrl?: string
  slugName?: string
  twitterUrl?: string
  websiteUrl?: string
}

export interface ItemOwnership {
  ownerId: string
  quantity: number
}

export type ItemAttribute = ParsedAttribute

export interface ItemMetadata {
  animationUrl: string | null
  attributes: ItemAttribute[]
  description: string | null
  externalUrl: string | null
  image: string | null
  name: string | null
}

export enum ItemsFilterType {
  HIDDEN = 'hidden'
}

export interface Item {
  chain: Chain
  chainId: ChainId
  collection: string
  collectionDescription: string | null
  collectionName: string | null
  collectionPfpUrl: string | null
  collectionSlug: string | null
  collectionSymbol: string | null
  id: string
  metadata: ItemMetadata | null
  owner: ItemOwnership | null
  tokenId: string
  tokenUri: string | null
  verified: CollectionVerificationStatus
}

export interface ItemDetail extends Item {
  collectionType: CollectionType | null
  collectionNumItems?: number
}

export enum ActivityType {
  MINT = 'mint',
  SALE = 'sale',
  TRANSFER = 'transfer'
}

export interface Activity {
  activityType: ActivityType
  chain: Chain
  chainId: ChainId
  collection: string
  collectionName: string
  fromAddress: string
  image: string | null
  name: string
  timestamp: number
  toAddress: string
  tokenId: string
  transactionHash: string
  currency?: string
  price?: bigint
}

export interface UserCollection {
  address: string
  name: string | null
  numItems: number
  pfpUrl: string | null
}

export interface HallOfFameEntry {
  address: string
  chain: Chain
  joe: boolean
  /** All-time AVAX volume (Joepegs plus project-reported external volume) */
  volume: number
}

export interface HallOfFameCollection {
  collection: Collection
  volume: number
}

export interface FeaturedCollection {
  address: string
  caption: string
  chain: Chain
  imageUrl: string
  pfpUrl: string
  priority: number
  title: string
}
